import { ArrowUpRight } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';

const CALENDLY_URL = 'https://calendly.com/satyam-thriveitmedia/discovery-call';

export const CTABanner = ({ heading = "Ready to Build Content That Actually Converts?", subtext = "Book a free 30-minute discovery call to discuss how we can grow your brand with influencer marketing, AI UGC, and content production.", buttonText = "Book a Free Call" }) => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-[#111111]" />
      <div className="absolute inset-0 grid-pattern opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center">
        <ScrollReveal>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#F5F5F0] mb-6">{heading}</h2>
          <p className="text-base md:text-lg font-body font-light text-[#888880] max-w-2xl mx-auto mb-10 leading-relaxed">{subtext}</p>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-banner-book-call"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#FFE500] text-[#0a0a0a] font-body font-medium tracking-wide hover:bg-[#FF5C35] transition-colors duration-300 group"
          >
            {buttonText}
            <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </ScrollReveal>
      </div>
    </section>
  );
};
